import React from "react";
import { Policy } from "../../../../redux/reducers/types/commonTypes";

export default function InvitesList({ policy }: { policy: Policy }) {
    return <div>List of users invited to the policy and their statuses</div>;
}
